import 'Styles/templates/index.scss';

import LazyVideo from '../components/lazy-video';
import productSliderApp from '../vue/product-slider/index';

import Swiper from 'swiper';
import SwiperCore, { Controller, EffectFade, Thumbs, A11y, Autoplay, Pagination } from 'swiper/core';
SwiperCore.use([Controller, EffectFade, Thumbs, A11y, Autoplay, Pagination]);

LazyVideo();
productSliderApp();

new Swiper('.bws__main', {
  slidesPerView: 1,
  spaceBetween: 16,
  slideClass: 'swiper__col',
  wrapperClass: 'swiper__row',
  effect: 'fade',
  allowTouchMove: true,
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.bws__next',
    prevEl: '.bws__prev'
  },
  a11y: {
    enabled: true
  },
  autoplay: {
    delay: 5000, // 5 seconds
    disableOnInteraction: false,
  },
  pagination: {
    el: '.bws__pagination',
    clickable: true
  }
});
